import React, { SVGProps } from 'react';

const UserCircle: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 16 16'
        width={16}
        height={16}
        {...props}
    >
        <path
            fill='currentColor'
            d='M3.45 11.828a.75.75 0 0 0 1.302.744L4.1 12.2zm.987-.216-.652-.373zm7.127 0 .651-.373zm-.315.96a.75.75 0 0 0 1.303-.744l-.652.372zM14 8h-.75c0 2.9-2.35 5.25-5.25 5.25v1.5A6.75 6.75 0 0 0 14.75 8zm-6 6v-.75A5.25 5.25 0 0 1 2.75 8h-1.5A6.75 6.75 0 0 0 8 14.75zM2 8h.75C2.75 5.1 5.1 2.75 8 2.75v-1.5A6.75 6.75 0 0 0 1.25 8zm6-6v.75c2.9 0 5.25 2.35 5.25 5.25h1.5A6.75 6.75 0 0 0 8 1.25zm1.65 4.5H8.9a.9.9 0 0 1-.9.9v1.5a2.4 2.4 0 0 0 2.4-2.4zM8 8.15V7.4a.9.9 0 0 1-.9-.9H5.6A2.4 2.4 0 0 0 8 8.9zM6.35 6.5h.75a.9.9 0 0 1 .9-.9V4.1a2.4 2.4 0 0 0-2.4 2.4zM8 4.85v.75a.9.9 0 0 1 .9.9h1.5A2.4 2.4 0 0 0 8 4.1zM4.1 12.2l.652.372.336-.588-.651-.372-.652-.373-.336.589zm.337-.588.65.372a2.25 2.25 0 0 1 1.954-1.134v-1.5a3.75 3.75 0 0 0-3.256 1.89zM7.04 10.1v.75h1.92v-1.5H7.041zm1.918 0v.75a2.25 2.25 0 0 1 1.954 1.134l.651-.372.651-.373A3.75 3.75 0 0 0 8.96 9.35zm2.605 1.512-.651.372.336.588.651-.372.652-.372-.337-.588z'
        />
    </svg>
);

export default UserCircle;
